// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-3WD5v";
var _4 = "orderNumber-3Yjey";
var _5 = "flight-1c8RJ";
var _6 = "price-2dxZp";
var _7 = "price__total-380WH";
var _8 = "details-3_JHI";
var _9 = "passengers-3IAdh";
var _a = "view-SSUId";
var _b = "timelimit-3Ogi5";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "orderNumber", _5 as "flight", _6 as "price", _7 as "price__total", _8 as "details", _9 as "passengers", _a as "view", _b as "timelimit" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "orderNumber": _4, "flight": _5, "price": _6, "price__total": _7, "details": _8, "passengers": _9, "view": _a, "timelimit": _b }
